/* Hero Slider — Vanilla JS */
(function() {
  const slider = document.querySelector('.ng-hero');
  if (!slider) return;

  const slides = slider.querySelectorAll('.ng-hero__slide');
  const dots = slider.querySelectorAll('.ng-hero__dot');
  const counter = slider.querySelector('.ng-hero__counter');
  const prevBtn = slider.querySelector('.ng-hero__arrow--prev');
  const nextBtn = slider.querySelector('.ng-hero__arrow--next');
  const contents = slider.querySelectorAll('.ng-hero__content-slide');
  const badges = slider.querySelectorAll('.ng-hero__badge-slide');
  const banners = slider.querySelectorAll('.ng-hero__banner');

  let current = 0;
  let isTransitioning = false;
  let autoplayTimer;
  const total = slides.length;
  const AUTOPLAY_MS = 6000;

  // Visningstid pr. slide — banner-slides bærer deres egen via data-duration
  function durationFor(index) {
    const slide = slides[index];
    if (!slide) return AUTOPLAY_MS;
    const ms = parseInt(slide.dataset.duration, 10);
    return ms > 0 ? ms : AUTOPLAY_MS;
  }

  // Vis det banner der hører til det aktive slide-indeks (hvis der er et)
  function syncBanners() {
    let hasBanner = false;
    banners.forEach(function(banner) {
      if (parseInt(banner.dataset.slideIndex, 10) === current) {
        banner.classList.add('active');
        hasBanner = true;
      } else {
        banner.classList.remove('active');
      }
    });
    slider.classList.toggle('ng-hero--banner-active', hasBanner);
  }

  function goTo(index) {
    if (!slides || slides.length === 0) return;
    if (!dots || dots.length === 0) return;
    if (isTransitioning || index === current) return;
    isTransitioning = true;

    // Hide current
    slides[current].classList.remove('active');
    if (contents[current]) contents[current].classList.remove('active');
    if (badges[current]) badges[current].classList.remove('active');
    dots[current].classList.remove('active', 'active--sale');

    current = index;

    // Show new
    slides[current].classList.add('active');
    if (contents[current]) contents[current].classList.add('active');
    if (badges[current]) badges[current].classList.add('active');

    var isSale = dots[current].dataset.sale === 'true';
    dots[current].classList.add('active');
    if (isSale) dots[current].classList.add('active--sale');

    syncBanners();

    // Update counter
    if (counter) {
      counter.textContent = String(current + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');
    }

    setTimeout(function() { isTransitioning = false; }, 600);
    resetAutoplay();
  }

  function next() {
    goTo((current + 1) % total);
  }

  function prev() {
    goTo((current - 1 + total) % total);
  }

  function resetAutoplay() {
    clearTimeout(autoplayTimer);
    if (total < 2) return;
    autoplayTimer = setTimeout(next, durationFor(current));
  }

  // Event listeners
  if (prevBtn) prevBtn.addEventListener('click', prev);
  if (nextBtn) nextBtn.addEventListener('click', next);

  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() { goTo(i); });
  });

  // Start autoplay
  syncBanners();
  resetAutoplay();
})();
